import { withLoader, withAsyncEnterLoader } from 'util/routeHelper';
import { getOrderItemByRoomId, bookingGoToStep } from 'actions/booking';
import { languageMapRoute } from 'util/i18n';
import { getRoomById } from 'actions/room';

export default store => ({
	path: 'booking',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'booking',
				),
			store,
			'BOOKING',
		),
	},
	onEnter: withAsyncEnterLoader(
		async ({ params: { id } }, replace, updateRatio) => {
			const { booking: { canAccess }, i18n: { lan } } = store.getState();

			if (!canAccess) {
				replace(`/${languageMapRoute(lan)}/room/${id}`);
				return;
			}

			store.dispatch(bookingGoToStep(0));
			updateRatio(0.5);

			await Promise.all([
				store.dispatch(getRoomById(id)),
				store.dispatch(getOrderItemByRoomId(id)),
			]);
			updateRatio(0.8);
		},
		store,
		'ENTER_BOOKING',
	),
});



// WEBPACK FOOTER //
// ./src/routes/Room/Booking/index.js